import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ComputerDesktopIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'

/**
 * Gate for features that only work on desktop (e.g. canvas-based AI
 * Workspace — drag/drop/resize/zoom is impractical on small touch screens).
 *
 * JS media-query detection so mobile users never mount the wrapped children,
 * avoiding wasted API fetches and state init that would run just to be
 * hidden behind a `hidden lg:block` CSS gate.
 *
 * Breakpoint: 1024px (Tailwind's `lg`). Live-reacts to resize.
 */
const DesktopOnly = ({
  children,
  title = 'Доступно только с компьютера',
  description = 'Эта функция использует большой рабочий стол с перетаскиванием блоков — на телефоне с ней неудобно работать. Открой в браузере на ноутбуке или компьютере.',
}) => {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches
  )

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)')
    const handler = (e) => setIsDesktop(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  if (isDesktop) return children

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6">
      <div className="max-w-sm w-full bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-zinc-900 flex items-center justify-center mb-5">
          <ComputerDesktopIcon className="w-8 h-8 text-brand-lime" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 tracking-tight mb-2">{title}</h1>
        <p className="text-sm text-slate-500 mb-6 leading-relaxed">{description}</p>
        <Link
          to="/training"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-brand-lime text-zinc-900 font-semibold text-sm hover:bg-brand-lime/90 transition-colors w-full"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          Вернуться на главную
        </Link>
      </div>
    </div>
  )
}

export default DesktopOnly
